import '../sass/post.scss';

(() => {
    const $posts = document.querySelectorAll('.post');

    if (!$posts) return;

    $posts.forEach($post => {
        const $carouselSmall = $post.querySelector('.post__related-carousel-small');
        const $carouselLarge = $post.querySelector('.post__related-carousel-large');

        const $navBtnPrev = $post.querySelector('.post__related-nav-btn--prev');
        const $navBtnNext = $post.querySelector('.post__related-nav-btn--next');

        const initCarousels = () => {
            let carouselSmall = null;
            let carouselLarge = null;

            if ($carouselSmall) {
                carouselSmall = new Swiper($carouselSmall);
            }

            if ($carouselLarge) {
                carouselLarge = new Swiper($carouselLarge, {
                    navigation: {
                        nextEl: $navBtnNext ?? null,
                        prevEl: $navBtnPrev ?? null,
                    },
                    rewind: true,
                });
            }
        };

        initCarousels();
    });
})();
